import { useMutation } from '@apollo/client/react';
import { useAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

import { DeleteFollowupDraftMessageDocument } from '~/graphql/generated/graphql';
import { messageModalState } from '~/state/partials/message_modal/atoms';

export const useDeleteDraftMessage = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [{ profile, patientId }, setMessageModalState] = useAtom(messageModalState);
  const [deleteDraftMessage, { data }] = useMutation(DeleteFollowupDraftMessageDocument);

  useEffect(() => {
    if (!data?.deleteMedicationFollowupDraftMessage) return;

    setMessageModalState((state) => ({
      ...state,
      draftMessageId: null,
    }));
  }, [data, setMessageModalState]);

  const deleteDraft = useCallback(async () => {
    setIsDeleting(true);
    setError(null);

    try {
      await deleteDraftMessage({
        variables: {
          input: {
            patientId: profile?.type === 'Patient' ? patientId : null,
            guestPatientId:
              profile?.type === 'DirectVisitor' ||
              profile?.type === 'WebVisitor' ||
              profile?.type === 'LineVisitor'
                ? patientId
                : null,
          },
        },
      });
      setIsDeleting(false);
    } catch (_error) {
      setError(_error?.message || 'エラーが発生しました');
      setIsDeleting(false);
      throw new Error('', { cause: _error });
    }
  }, [patientId, profile?.type, deleteDraftMessage]);

  return {
    deleting: isDeleting,
    error,
    deleteDraft,
  };
};
